export const setUpdatedValues = (modelData, value,elementName,modelId) => {
    for(let i=0;i<modelData.clModels.length;i++){
        if(modelData.clModels[i].id === modelId){
            for(let j=0;j<modelData.clModels[i].dataValues.length;j++){
                if(modelData.clModels[i].dataValues[j].elementName === elementName){
                    modelData.clModels[i].dataValues[j].value =  value
                    modelData.clModels[i].dataValues[j].isOverrided =  true
                }
        }
    }
    }
    return modelData
}

export const setWeightageValues = (modelData, value,modelId) => {
    for(let i=0;i<modelData.clmMetaData.length;i++){
        if(modelData.clmMetaData[i].creditLimitModelId === modelId){
            modelData.clmMetaData[i].weightage =value
        }
    }
    return modelData
}